/* eslint-disable no-unused-vars */
import React, {
  useEffect,
  useState,
} from "react";
import {
  Dialog,
  AppBar,
  Toolbar,
  IconButton,
  Typography,
} from "@mui/material";
import Slide from "@mui/material/Slide";
import { IconX } from "@tabler/icons";
import FmdGoodIcon from "@mui/icons-material/FmdGood";
import PolygonGeofenceMap from "src/components/mapFencing/PolygonGeofenceMap";
import GeofencingService from "src/service/geofencing";
import { useParams } from "react-router";
import ReportFence from "src/components/mapFencing/ReportFence";
import { values } from "lodash";
import ReportService from "src/service/reports";
import moment from "moment";

const Transition = React.forwardRef(
  function Transition(props, ref) {
    return (
      <Slide
        direction="up"
        ref={ref}
        {...props}
      />
    );
  }
);

const FullscreenDialog = ({
  id,
  radialCoordinates,
  radius,
  markerCoordinates,
  locationName,
  datetime,
  status,
}) => {
  console.log(
    id,
    radialCoordinates,
    radius,
    markerCoordinates
  );
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const [geofenceData, setGeofenceData] =
    useState(null);

  // State to store geofence data and loading state

  const [isLoading, setIsLoading] =
    useState(true); // Add loading state

  // useEffect(() => {
  //   const fetchData = async () => {
  //     try {
  //       const locationdata = await ReportService?.[apiEndpoint]({
  //         id: id,
  //       });
  //       console.log("location interest===", locationdata);
  //       setGeofenceData(locationdata.data[0]);
  //       setIsLoading(false);
  //     } catch (error) {
  //       console.error("Error fetching geofencing data:", error);
  //       setIsLoading(false);
  //     }
  //   };

  //   fetchData();
  // }, [id]);

  return (
    <>
      {/* <Button variant="contained" color="error" fullWidth>
        Open Fullscreen Dialog
      </Button> */}
      <FmdGoodIcon
        style={{
          color: "purple",
          fontSize: "22px",
          cursor: "pointer",
          marginLeft: "10px",
        }}
        onClick={handleClickOpen}
      />
      <Dialog
        fullScreen
        open={open}
        onClose={handleClose}
        TransitionComponent={Transition}
      >
        <AppBar sx={{ position: "relative" }}>
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              onClick={handleClose}
              aria-label="close"
            >
              <IconX width={24} height={24} />
            </IconButton>
            <Typography
              ml={2}
              flex={1}
              variant="h6"
              component="div"
            >
              Map View
            </Typography>
          </Toolbar>
        </AppBar>
        <ReportFence
          center={{
            lat: radialCoordinates?.lat,
            lng: radialCoordinates?.lng,
          }}
          markerPosition={{
            lat: markerCoordinates.lat,
            lng: markerCoordinates.lng,
          }}
          radius={radius}
        />

        <div className="mt-5 ms-5">
          <h6 className="font-bold">
            Location Name :{" "}
            <span>{locationName ?? "NA"}</span>
            <br />
            DateTime :{" "}
            <span>
              {moment(datetime).format(
                "DD-MM-YYYY hh:mm:ss a"
              ) ?? "NA"}
            </span>
            <br />
            Status : <span>{status ?? "NA"}</span>
          </h6>
        </div>
      </Dialog>
    </>
  );
};

export default FullscreenDialog;
